import { getAddendumAndNotices, userAddendumAndNoticesSummaryApi } from "../../apis/nontransactional";
import { APP_INFO_PARAMS, LOCAL_STORAGE_KEYS, NETWORK_RESPONSE_STATUS } from "../../utils/global_variables";
import { ADDENDUMANDNOTICES } from "../actionTypes";
import { deepClone, getApiExchangeMktSegment, getApiExchangeNameFromMktSegId, getAppInfoData, getDecryptLocalStorage, getStorageWithMultiTabCheck, getMarketAllowed, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";



// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
export const checkAddendumNotice = (appInfo) => async (dispatch) => {
    let isAddEnddumNoticeOn = getAppInfoData(APP_INFO_PARAMS?.APP_ADDENDUM_NOTICE);
    if (isAddEnddumNoticeOn === 'ON') {//
        const activeSession = JSON?.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        let mktAllowed = getApiExchangeMktSegment(activeSession?.data?.exchanges);
        const login_type = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_LOGGED_IN_TYPE));
        dispatch(getAddEndumAndNotice({ nAllowedId: mktAllowed, login_type: login_type === 'MPIN_TDES' ? "MPIN" : "PASSWORD" }));
    } else { }
};
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End

// Ameersha N : 16-10-2024 : BT-116461 Breeze - Addendum and Notices --Start
export const getAddEndumAndNotice = (payload) => async (dispatch) => {
    const objResp = await getAddendumAndNotices(payload);
    if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
        let arrLocalAcceptedIds = JSON?.parse(getDecryptLocalStorage('ACCEPTED_NOTICES_ID'));
        let arrLocalRejectedIds = JSON?.parse(getDecryptLocalStorage('REJECTED_NOTICES_ID'));
        const activeSession = JSON?.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        const arrUserAllowedExchanges = activeSession?.data?.exchanges;
        if ((arrLocalAcceptedIds && arrLocalAcceptedIds?.length > 0) || (arrLocalRejectedIds && arrLocalRejectedIds?.length > 0)) {
            // removeing alredy accepted or rejected notices 
            let arrFilteredNotices = [];
            objResp?.data?.data?.forEach((eachNotice) => {
                let isPresent = arrUserAllowedExchanges?.includes(getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(eachNotice?.segment_allowed)));
                if (isPresent) {
                    arrFilteredNotices?.push(eachNotice);
                }
            });
            let copy = deepClone(arrFilteredNotices)?.filter((eachNotice) => (!arrLocalAcceptedIds?.includes(eachNotice?.notice_id) && !arrLocalRejectedIds?.includes(eachNotice?.notice_id)));
            dispatch(addEndumandNoticeSuccess([...copy]));
        } else {
            dispatch(addEndumandNoticeSuccess(objResp?.data?.data));
        }
        return Promise?.resolve(objResp);
    } else {
        dispatch(addEndumandNoticeFailure([]));
        return Promise?.reject(objResp);
    }
};
// Ameersha N : 16-10-2024 : BT-116461 Breeze - Addendum and Notices -- End

// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
export const updateIsAddenddumModalAction = (payload) => {
    return { type: ADDENDUMANDNOTICES?.UPDATE_IS_ADD_ENDUM_MODAL_OPEN, payload };
};

export const addEndumandNoticeSuccess = (payload) => {
    return { type: ADDENDUMANDNOTICES.GET_ADD_ENDUMAND_NOTICES_SUCCESS, payload };
};

export const addEndumandNoticeFailure = (payload) => {
    return { type: ADDENDUMANDNOTICES.GET_ADD_ENDUMAND_NOTICES_FAILURE, payload };
};

export const updateAddEndNoticeAcceptedOrRejected = (payload) => {
    return { type: ADDENDUMANDNOTICES?.UPDATE_IS_ADD_END_DUM_ACCEPTED_OR_REJECTED, payload };
};
// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End



export const getuserAddendumAndNoticesSummaryAction = () => async (dispatch, getState) => {
    let objResp = await userAddendumAndNoticesSummaryApi();
    if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
        dispatch(updateAdddndumReports(objResp?.data?.data));
    } else {

    }
};


export const updateAdddndumReports = (payload) => {
    return { type: ADDENDUMANDNOTICES?.UPDATE_ADD_ENDUM_NOTICES_REPORT, payload };
};


export const updateAddNotLastLocation = payload => {
    return { type: ADDENDUMANDNOTICES?.UPDATE_ADD_NOT_LAST_LOCATION, payload };
};